import moment from 'moment'

const formatDate = date =>
  moment(date, moment.defaultFormatUtc).format('HH:mm D MMM YYYY')

export default formatDate
